var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"small":"","label":"","outline":"","color":_vm.statusMap[_vm.status].color}},[_c('strong',[_vm._v(_vm._s(_vm.statusMap[_vm.status].label))])])}
var staticRenderFns = []

export { render, staticRenderFns }